module.exports = __webpack_public_path__ + "img/emparejamiento.7b243c47.svg";